import { Component, OnInit, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DashboardService } from '../inject-solar/dashboard/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
@Component({
  selector: 'app-error-log-admin',
  templateUrl: './error-log-admin.component.html',
  styleUrls: ['./error-log-admin.component.scss']
})
export class ErrorLogAdminComponent implements OnInit {
  @ViewChild('input', { read: MatInput, static: false }) input: MatInput
  @ViewChild('input1', { read: MatInput, static: false }) input1: MatInput
  @ViewChild('input2', { read: MatInput, static: false }) input2: MatInput
  @ViewChild('input3', { read: MatInput, static: false }) input3: MatInput

  private ResponseVerifiedUnclearAlarms$: Subject<any> = new Subject();
  private ResponseVerifiedClearAlarms$: Subject<any> = new Subject();
  pipe = new DatePipe('en-US');
  formula: string = "Download_CSV";
  listOfNormalAndWmsUser: any;
  page = 1;
  offsetClearAlarms = 0;
  limit = 10;
  page1 = 1;
  roleName: string;
  count: number;
  clearedAlarmsCSV: any = [];
  alarmForm: FormGroup;
  alarmFormClear: FormGroup;
  role: any;
  epcId: any;
  AlarmsTab: any;
  offsetUnClearAlarms = 0;
  unClearedAlarmsCount: number;
  unClearedAlarms: any = [];
  clearedAlarms: any = [];
  allEpc: any;
  unClearedCSVAlarms: any = [];
  SadminAccess: any = [];
  access: any;
  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'Error Log') {
          this.access = x.access
        }
      })
    }
    this.AlarmsTab = 'UnClearedAlarmsTab';
    this.alarmForm = this.fb.group({
      user_id: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      epc_id: ['', Validators.required]
    }
    );
    this.alarmFormClear = this.fb.group({
      user_id: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      epc_id: ['', Validators.required]
    }
    );
    this.getAllEpc()
    this.getUnclearedAlarms(0);
  }
  showClearedAlarmsTab(Tab) {
    this.AlarmsTab = Tab;
    this.offsetClearAlarms=0;
    this.getClearedAlarms(this.offsetClearAlarms);
    // this.getClearedAlarms(0);
    this.resetUnClearedAlarams();

  }
  // cleared alarms Tab
  showUnClearedAlarmsTab(Tab) {
    this.AlarmsTab = Tab;
    this.offsetUnClearAlarms=0;
    this.getUnclearedAlarms(this.offsetUnClearAlarms);
    // this.getUnclearedAlarms(0);
    this.resetClearedAlarams()
  }
  // reset value ClearedAlarams For Admin
  public resetClearedAlarams() {

    // if(this.access != '2'){
    //   this.input2.value = '';
    //   this.input3.value = '';
    //   this.alarmFormClear.reset();
    //  }
    this.alarmFormClear.controls.to_date.setValue('');
    this.alarmFormClear.controls.from_date.setValue('');
    this.alarmFormClear.reset();
    this.offsetClearAlarms=0;
    this.getClearedAlarms(this.offsetClearAlarms);
    // this.getClearedAlarms(0);
  }
  // reset value ClearedAlarams For Admin
  public resetUnClearedAlarams() {
  //  if(this.access != '2'){
  //   this.input.value = '';
  //   this.input1.value = '';
  //   this.alarmForm.reset();
  //  }
  this.alarmForm.controls.to_date.setValue('');
  this.alarmForm.controls.from_date.setValue('');
  this.alarmForm.reset();
  this.offsetUnClearAlarms=0;
  this.getUnclearedAlarms(this.offsetUnClearAlarms);
    // this.getUnclearedAlarms(0);
  }
  getUnclearedAlarms(offset) {
    // nevigate first page
    if (offset == 0) {
      this.page1 = 1
    }
    var alarmObj = {
      // epc_id: this.epcId,
      user_id: this.alarmForm.controls['user_id'].value,
      start_date: this.pipe.transform(this.alarmForm.controls['to_date'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.alarmForm.controls['from_date'].value, "yyyy-MM-dd"),
      limit: this.limit,
      offset: offset
    }
    this.dashbord.getAdminUnclearedAlarms(alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlarms$))
      .subscribe(
        async data => {
          this.unClearedAlarmsCount = 0;
          this.unClearedAlarms = [];
          if (data.status == true || data.status == 'true') {
            this.unClearedAlarmsCount = data.count
            this.unClearedAlarms = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get clearedAlarms
  getClearedAlarms(offset) {
    // nevigate first page
    if (offset == 0) {
      this.page = 1
    }
    var alarmObj = {
      user_id: this.alarmFormClear.controls['user_id'].value,
      start_date: this.pipe.transform(this.alarmFormClear.controls['to_date'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.alarmFormClear.controls['from_date'].value, "yyyy-MM-dd"),
      limit: this.limit,
      offset: offset
    }
    this.dashbord.getAdminClearedAlarms(alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedClearAlarms$))
      .subscribe(
        async data => {
          this.count = 0;
          this.clearedAlarms = [];
          if (data.status) {
            this.count = data.count
            this.clearedAlarms = data.resultObject;

          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // unCleare Alarms
  selectUnClearAlarmsEpc() {
    this.getListofUsers(this.alarmForm.controls['epc_id'].value)
  }
  // unCleare Alarms
  selectClearAlarmsEpc() {
    this.getListofUsers(this.alarmFormClear.controls['epc_id'].value)
  }
  // get all Epc
  getAllEpc() {

    var getEpcObj = {
      search: "",
      limit: 0,
      offset: 0
    }
    this.dashbord.getAllEpcUser(getEpcObj)
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.allEpc = data.resultObject;
          this.toastr.success(data.message);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }

  // getAll User Under Epc
  getListofUsers(epc_id) {
    var UserObj = {
      epc_id: epc_id
    }
    this.dashbord.getAdminNormalAndWmsUser(UserObj)
      .subscribe(
        async data => {
          if (data.status) {
            this.listOfNormalAndWmsUser = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPageClearAlarms(pageIndex): void {
    this.offsetClearAlarms = (pageIndex - 1) * 10;
    this.getClearedAlarms(this.offsetClearAlarms);
  }

  nextPageUncleredAlarams(pageIndex): void {
    this.offsetUnClearAlarms = (pageIndex - 1) * 10;
    this.getUnclearedAlarms(this.offsetUnClearAlarms);
  }

  // download csv for cleared alarm
  downloadClearedAlaramsCSV() {
    var alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmFormClear.controls['user_id'].value,
      start_date: this.pipe.transform(this.alarmFormClear.controls['to_date'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.alarmFormClear.controls['from_date'].value, "yyyy-MM-dd"),
      limit: '0',
      offset: '0'
    }
    this.dashbord.getAdminClearedAlarms(alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedClearAlarms$))
      .subscribe(
        async data => {
          if (data.status) {
            this.count = data.count
            this.clearedAlarmsCSV = data.resultObject;
            var data = this.clearedAlarmsCSV;
            var options = {
              title: 'Cleared Alarms',
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              useBom: true,
              headers: ['Login Id', 'Device Name', ' Name', 'Inverter Name', 'Alarm Id', 'Occurance Time','Clearance Time ', 'Alarm Message']
            };
            new Angular5Csv(data, this.formula, options);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  //download csv fo uncleared alarm
  csvDownloadUnClearedAlarams() {
    var alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmForm.controls['user_id'].value,
      start_date: this.pipe.transform(this.alarmForm.controls['to_date'].value, "yyyy-MM-dd"),
      end_date: this.pipe.transform(this.alarmForm.controls['from_date'].value, "yyyy-MM-dd"),
      limit: '0',
      offset: '0'
    }
    this.dashbord.getAdminUnclearedAlarms(alarmObj)
      .subscribe(
        async data => {
          this.unClearedAlarmsCount = 0;
          this.unClearedCSVAlarms = [];
          if (data.status == true || data.status == 'true') {
            this.unClearedCSVAlarms = data.resultObject;
            var data = this.unClearedCSVAlarms;
            var options = {
              title: 'Un-Cleared Alarms',
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              useBom: true,
              headers: ['login_id', 'Device Name', 'Name', 'Inverter Name', 'Alarm Id', 'Occurance Time',  'Alarm Message']
            };
            new Angular5Csv(data, this.formula, options);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
}
